"use client";

import React from "react";
import { HardHat, Truck, Settings2, Key } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
const advantages = [{
  id: "construction",
  title: "Regional Heavy-Haul",
  description: "Our fleet of semi-trucks services the Southeast region with high-weight capacities, optimized for bulk material transport and long-distance reliability.",
  icon: Truck
}, {
  id: "logistics",
  title: "DFW Last-Mile",
  description: "Agile small and medium vehicles serving the Dallas/Fort Worth market, ensuring precise delivery for local lumber yards and residential sites.",
  icon: HardHat
}, {
  id: "hardware",
  title: "Specialized Stone Handling",
  description: "Expert transport for stone yards and suppliers, utilizing specialized equipment to handle heavy, fragile, and oversized bulk materials safely.",
  icon: Settings2
}, {
  id: "concierge",
  title: "Equipment & Safety",
  description: "Every vehicle is outfitted with hydraulic lift gates, industrial-grade straps, and heavy-duty tarps to guarantee cargo security and condition.",
  icon: Key
}];
export default function TheFullServiceAdvantage() {
  return <section data-section-id="142558" id="capacity-equipment" className="bg-background text-foreground py-24 px-4 md:px-8 border-y-2 border-border">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 max-w-3xl">
          <h2 className="text-4xl md:text-6xl font-default font-extrabold tracking-tighter uppercase mb-6 text-foreground">
            Capacity & Equipment
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans font-normal leading-relaxed">
            TransitLink operates a precision fleet engineered for industrial demands. From specialized stone handling to regional heavy-haul, we provide the weight capacity and specialized gear—including lift gates and tarps—to move your business forward. Call +1-469-590-4364 for custom quotes.
          </p>
        </div>

        {}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((adv, i) => <Card key={adv.id} data-index={i} className="border-2 border-border bg-card rounded-sm shadow-none hover:bg-primary/10 hover:border-primary transition-all duration-300">
              <CardHeader className="pb-4">
                <adv.icon className="w-10 h-10 text-primary mb-6" strokeWidth={2} />
                <CardTitle className="font-default text-base font-bold tracking-tight uppercase text-foreground">
                  {adv.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-muted-foreground leading-relaxed font-sans font-normal">
                  {adv.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="md:hidden">
          <Tabs defaultValue={advantages[0].id} className="w-full">
            <TabsList className="w-full flex flex-col h-auto bg-transparent p-0 gap-2 mb-8">
              {advantages.map((adv, i) => <TabsTrigger key={adv.id} data-index={i} value={adv.id} className="w-full justify-start data-[state=active]:bg-primary data-[state=active]:text-primary-foreground border-2 border-border rounded-sm py-4 px-4 text-xs uppercase tracking-widest font-default font-bold">
                  <adv.icon className="w-4 h-4 mr-3" strokeWidth={2} />
                  {adv.title}
                </TabsTrigger>)}
            </TabsList>
            {advantages.map((adv, i) => <TabsContent key={adv.id} data-index={i} value={adv.id} className="mt-0 focus-visible:outline-none focus-visible:ring-0">
                <Card className="border-2 border-primary bg-primary/5 rounded-sm shadow-none">
                  <CardHeader className="pb-4">
                    <adv.icon className="w-12 h-12 text-primary mb-6" strokeWidth={2} />
                    <CardTitle className="font-default text-lg font-bold tracking-tight uppercase text-foreground">
                      {adv.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-foreground text-base leading-relaxed font-sans font-normal">
                      {adv.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </TabsContent>)}
          </Tabs>
        </div>
      </div>
    </section>;
}